import React from 'react';
import { INumericSelectProps, NumericSelectValue } from './types';

export const NumericSelect: React.FC<INumericSelectProps> = ({
  value,
  className,
  children,
  onChange,
  ...rest
}) => {
  const convertToString = (value: NumericSelectValue): string =>
    value ? value.toString() : '';
  const convertToNumber = (value: string): NumericSelectValue => {
    const parsedValue = Number.parseInt(value);

    return isNaN(parsedValue) ? null : parsedValue;
  };

  const handleChange = (event: React.FormEvent<HTMLSelectElement>) =>
    onChange(convertToNumber(event.currentTarget.value));

  return (
    <select
      className={`form-control ${className}`}
      value={convertToString(value)}
      onChange={handleChange}
      {...rest}
    >
      {children}
    </select>
  );
};
